module.exports = __webpack_public_path__ + "img/edit.71f16683.svg";